import { ClientConfig } from 'yeself-common/typings/Config';

type StringifiedInjectedClientConfig = string & { readonly __tag: unique symbol };

/**
 * The read-only constant that contains config inject placeholder.
 * To avoid injection of config, the string is divided into an array.
 */
const INJECT_PLACEHOLDER_ARRAY = [
    '{',
    '{',
    'y',
    'e',
    's',
    'e',
    'l',
    'f',
    '-',
    'c',
    'l',
    'i',
    'e',
    'n',
    't',
    '-',
    'c',
    'o',
    'n',
    'f',
    'i',
    'g',
    '-',
    'y',
    'e',
    's',
    'e',
    'l',
    'f',
    '}',
    '}',
] as const;

const injectedClientConfig = '{{yeself-client-config-yeself}}' as StringifiedInjectedClientConfig;

const config =
    injectedClientConfig !== INJECT_PLACEHOLDER_ARRAY.join('')
        ? (JSON.parse(window.atob(injectedClientConfig)) as Partial<ClientConfig>)
        : {};

const yeselfConfig = { ...(process.env.YESELF_CONFIG as unknown as ClientConfig), ...config };

export default yeselfConfig;
